import * as Yup from 'yup';

const formValidation = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  title: Yup.string().required('Title is required'),
  message: Yup.string().required('Message is required'),
  lang: Yup.string().required('Language is required'),
  deeplink: Yup.string().required('Deeplink is required'),
  dayOfWeek: Yup.number().required('Day of week is required').min(0).max(6),
});

export default formValidation;
